import { publicHref } from '../lib/publicUrls';
import './EditorialPages.css';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import SEO from '../components/SEO';

const NotFoundPage = () => (
  <div className="dv-editorial dv-editorial--not-found" data-testid="page-not-found">
    <SEO title="Page Not Found" description="The requested Delta Valley Health Club page could not be found." />
    <div className="container-custom dv-editorial__not-found-inner">
      <div className="dv-size-heading text-7xl font-black text-[#0072BB] mb-4">404</div>
      <h1 className="dv-size-heading text-3xl md:text-4xl font-bold mb-4">This Page Couldn&apos;t Be Found</h1>
      <p className="dv-size-lede text-gray-600 text-lg mb-8">The page may have moved during our website transition. Use one of the links below to continue.</p>
      <div className="dv-editorial__recovery">
        <Button asChild size="lg"><Link to="/">Go Home</Link></Button>
        <Button asChild size="lg" variant="outline"><Link to={publicHref("/membership")}>View Memberships</Link></Button>
        <Button asChild size="lg" variant="outline"><Link to={publicHref("/book-a-tour")}>Book a Tour</Link></Button>
      </div>
    </div>
  </div>
);

export default NotFoundPage;
